// Re-export configuration
export { AppConfig, isDevelopment, isProduction } from './config';

// Re-export strings for localization
export * from './strings';

// Re-export marketplace constants and strings
export * from './marketplaceConstants';
export { MARKETPLACE_COLORS } from './marketplaceColors';

// Re-export unified color system
export {
  PRIMITIVE_COLORS,
  SEMANTIC_COLORS,
  COMPONENT_COLORS,
  MOBILE_LIGHT_COLORS,
  RESIDENT_COLORS,
} from './residentColors';
export type { PrimitiveColor, SemanticColor, ComponentColor } from './residentColors';

// Application constants
export const APP_CONSTANTS = {
  // Navigation
  TAB_BAR_HEIGHT: 50,
  NAVIGATION_TITLE_FONT_SIZE: 15,
  NAVIGATION_LARGE_TITLE_FONT_SIZE: 22,
  
  // UI
  BUTTON_CORNER_RADIUS: 8,
  TEXT_FIELD_HEIGHT: 48,
  INPUT_FONT_SIZE: 16,
  LABEL_FONT_SIZE: 14,
  
  // Timeouts
  DEFAULT_ANIMATION_DURATION: 300,
  DEBOUNCE_DELAY: 500,
  
  // Validation
  MAX_INPUT_LENGTH: 240,
  
  // Styling
  ENABLED_ALPHA: 1.0,
  DISABLED_ALPHA: 0.5,
} as const;

// Color constants (matching iOS app)
export const COLORS = {
  PRIMARY: '#007AFF',
  SECONDARY: '#E0E0E0',
  SUCCESS: '#4CAF50',
  WARNING: '#FF9800',
  ERROR: '#F44336',
  TEXT_PRIMARY: '#000000',
  TEXT_SECONDARY: '#666666',
  TEXT_TERTIARY: '#999999',
  BACKGROUND_PRIMARY: '#FFFFFF',
  BACKGROUND_SECONDARY: '#F5F5F5',
  TEXT_WHITE: '#EEF1F4',
  BUTTON_PRIMARY: '#4773FE', // blue
  BUTTON_PRIMARY_DISABLED: '#6B8EFE',
  INPUT: "#464646",
  INPUT_BORDER: "#757575",
  BUTTON_SECONDARY: "#f55560", // red
} as const;

export const MAX_ATTACHMENTS = 7;

// Maintenance constants
export const MAINTENANCE_CONSTANTS = {
  MINIMUM_TIME_SLOTS: 3,
  SEVERITY_FALLBACK_LABELS: [
    "It doesn't affect me at the moment",
    "It creates discomfort",
    "No reasonable workaround available",
    "Can't use the apartment",
  ],
} as const;

// Re-export utilities for convenience
export { formatAsPhoneNumber, cleanPhoneNumber, isValidPhoneNumber } from '../../utils/residents/utils';

// Re-export invitation status constants
export * from './invitationStatus';

// Re-export admin constants
export * from '../admin'; 